module.exports = __webpack_public_path__ + "static/media/unionpay.c3cd6882.png";